module.exports = "/static/fonts/OpenSans-Light.woff2";